<template>
    <v-sheet style="width:100%" class="grey lighten-5 px-0 pt-0 pb-2">
        <v-row dense class="grey lighten-5 mr-0">
            <v-col :cols="getCols('operator')" class="d-flex align-center">
                <span class="mr-2 pr-4 text--primary"><translation-container :context="this" value="If"></translation-container></span>
                <v-select outlined dense
                    :label="Translate('Operator')"
                    style="width:165px;"
                    :items="condition_types"
                    item-text="text"
                    item-value="value"
                    :menu-props="{ offsetY: true }"
                    v-model="itemCondition"
                    @change="thresholdChanged"
                    background-color="white"
                    hide-details
                    :rules="operatorRules"
                    :error-messages="operatorErrorMessages"
                    :error="operatorErrorMessages.length > 0"></v-select>
            </v-col>
            <v-col :cols="getCols('units_from')" v-if="itemCondition != 'missing'" >
                <v-select outlined dense
                        style="width:100%;"
                        :items="relative_units"
                        item-text="text"
                        item-value="value"
                        :menu-props="{ offsetY: true }"
                        v-model="units_from"
                        @change="thresholdChanged"
                        background-color="white"
                        hide-details
                        :rules="unitsFromRules"
                        :error-messages="unitsFromErrorMessages"
                        :error="unitsFromErrorMessages.length > 0">
                </v-select>   
            </v-col>
            <v-col :cols="getCols('abs_from')" v-if="units_from == 'abs' && units_from !== 'now'  && itemCondition != 'missing'">
                <v-text-field v-if="units_from == 'abs' && units_from !== 'now'"
                        style="grid-column: span 2;"
                        outlined dense
                        v-model="abs_from"
                        type="datetime-local"
                        step="900"
                        :label="Translate('Value')"
                        @change="thresholdChanged"
                        background-color="white"
                        class="pr-3"
                        hide-details
                        :rules="absFromRules"
                        :error-messages="absFromErrorMessages"
                        :error="absFromErrorMessages.length > 0">
                </v-text-field>
            </v-col>
            <v-col :cols="getCols('relative_from')" v-if="units_from != 'abs' && units_from !== 'now' && itemCondition != 'missing'">                    
                <v-text-field v-if="units_from != 'abs' && units_from !== 'now'"
                        outlined dense
                        type="number"
                        :label="Translate('Value')"
                        v-model.number="value_from"
                        @input="thresholdChanged"
                        background-color="white"
                        class="pr-3"
                        hide-details
                        :rules="valueFromRules"
                        :error-messages="valueFromErrorMessages"
                        :error="valueFromErrorMessages.length > 0"
                                >
                </v-text-field>
            </v-col>
   
            <v-col :cols="getCols('format1')" class="d-flex align-center" v-if="itemCondition != 'inRange' && itemCondition != 'notInRange'">
                <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
                <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
            </v-col>
        </v-row>
        <v-row v-if="itemCondition == 'inRange' || itemCondition == 'notInRange'" dense class="grey lighten-5 d-flex align-center mr-0">  
            <v-col :cols="getCols('range_units_to')" class="d-flex align-center">
                <span class="mr-2 text--primary" width="44px"><translation-container :context="this" value="and"></translation-container></span>
                <v-select style="width: 100%;"
                        outlined dense
                        :items="relative_units"
                        item-text="text"
                        item-value="value"
                        :menu-props="{ offsetY: true }"
                        v-model="units_to"
                        @change="thresholdChanged"
                        background-color="white"
                        hide-details
                        :rules="unitsToRules"
                        :error-messages="unitsToErrorMessages"
                        :error="unitsToErrorMessages.length > 0">
                </v-select>
            </v-col>
            <v-col :cols="getCols('range_value_to')" v-if="units_to != 'abs' && units_to !== 'now'">
                <v-text-field v-if="units_to != 'abs' && units_to !== 'now'"
                        style="grid-column: span 2;"
                        outlined dense
                        type="number"
                        :label="Translate('Value')"
                        v-model.number="value_to"
                        @input="thresholdChanged"
                        background-color="white"
                        hide-details
                        :rules="valueToRules"
                        :error-messages="valueToErrorMessages"
                        :error="valueToErrorMessages.length > 0">
                </v-text-field>
            </v-col>
            <v-col :cols="getCols('range_abs_to')" v-if="units_to == 'abs' && units_to !== 'now'">
                <v-text-field v-if="units_to == 'abs' && units_to !== 'now'"
                        outlined dense
                        v-model="abs_to"
                        type="datetime-local"
                        step="900"
                        :label="Translate('Value')"
                        @change="thresholdChanged"
                        background-color="white"
                        hide-details
                        :rules="absToRules"
                        :error-messages="absToErrorMessages"
                        :error="absToErrorMessages.length > 0">
                </v-text-field>
            </v-col>
            
            <v-col :cols="getCols('format2')" class="d-flex align-center">
                <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
                <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
            </v-col>
        </v-row>
    </v-sheet>
</template>
<script>
    
    import utils from '@/Shared/utils.jsx';
    import filters from '@/Shared/filters.js';
    import common from './common.js';
    import methods from '@/Shared/methods';

    import ThresholdformatOptions from './threshold_formatOptions.vue';

    export default {
        components: {
            ThresholdformatOptions
        },
        data: function () {
            return {
                itemCondition: '',
                value_from: '',
                value_to: 0,
                units_from: 'd',
                units_to: '',
                round_from: true,
                round_to: true,
                abs_from: '',
                abs_to: '',
                color:'',
                operatorErrorMessages:[],
                valueToErrorMessages: [],
                valueFromErrorMessages: [],
                absToErrorMessages: [],
                absFromErrorMessages: [],
                unitsToErrorMessages: [],
                unitsFromErrorMessages: [],
            }
        },
        props: {
            item: Object,
            value: null,
            EventBus: null,
        },
        created() {
            if (!this.value || Object.keys(this.value).length < 1) {

                // Default values for the date threshold
                const now = new Date();
                const year = now.getFullYear();
                let mon = `${now.getMonth()}`; if (mon.length < 2) mon = '0' + mon;
                let day = `${now.getDate()}`; if (day.length < 2) day = '0' + day;

                this.abs_from = `${year}-${mon}-${day}T00:00`; // '2018-06-12T19:30'; // new Date().toISOString();
                this.abs_to = this.abs_from;
            }
            else {
                this.valueChanged(this.value);
            }

            //this.EventBus.$on(`${this.item.ColId}_changed`, this.valueChanged);
        },
        //destroyed() {
        //    this.EventBus.$off(`${this.item.ColId}_changed`, this.valueChanged);
        //},
        watch: {
            abs_to: function (newv) {
                console.warn(`***  abs_to: ${newv} ***`);
            },
            itemCondition  : function (val) {
              this.valueChanged(val);
            }
        },
        computed: {
            relative_units: function() {
                return [
                    { text: this.Translate('Now'), value: 'now' },
                    { text: this.Translate('Seconds ago'), value: 's' },
                    { text: this.Translate('Minutes ago'), value: 'm' },
                    { text: this.Translate('Hours ago'), value: 'h' },
                    { text: this.Translate('Days ago'), value: 'd' },
                    { text: this.Translate('Weeks ago'), value: 'w' },
                    { text: this.Translate('Months ago'), value: 'M' },
                    { text: this.Translate('Years ago'), value: 'y' },
                    { text: this.Translate('Absolute'), value: 'abs' },
                ];
            },
            condition_types: function() {
                return [
                    { text: this.Translate('Greater Than'), value: 'greaterThan' },
                    { text: this.Translate('Greater Than or Equal To'), value: 'greaterThanOrEqualTo' },
                    { text: this.Translate('Less Than'), value: 'lessThan' },
                    { text: this.Translate('Less Than or Equal To'), value: 'lessThanOrEqualTo' },
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Between'), value: 'inRange' },
                    { text: this.Translate('Not Between'), value: 'notInRange' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            computeCurrentStart: function() {
                return common.getRelativeDate(this.units_from, this.value_from, this.abs_from, this.round_from);
            },
            computeCurrentEnd: function () {
                return common.getRelativeDate(this.units_to, this.value_to, this.abs_to, this.round_to, true);
            },
            friendlyFromUnit: function() {
                return this.getFriendlyUnit(this.units_from);
            },
            friendlyToUnit: function () {
                return this.getFriendlyUnit(this.units_to);
            },

            computeLocalStart: function () {
                if (this.abs_from)
                    return common.ISO8601ToLocal(this.abs_from);
                return '';
            },
            computeLocalEnd: function () {
                if (this.abs_to)
                    return common.ISO8601ToLocal(this.abs_to);
                return '';
            },  
            isRangeBased: function() {
                    return this.itemCondition == 'inRange' || this.itemCondition == 'notInRange';
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },
            absFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            unitsFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            valueFromRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            unitsToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please select an option')
                ];
            },
            valueToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
            absToRules() {
                return [
                    v => !!v || v === 0 || this.Translate('Please enter a value')
                ];
            },
        },
        methods: {
            ...methods,
                     
            getCols: function(name) {

                    switch(name){
                        case "operator": return this.itemCondition == 'missing' ? 9 : 3;
                        case "units_from": return (this.units_from == 'now' ? 6 : 2) + (this.isRangeBased ? 3 : 0);
                        case "abs_from": return 4;
                        case "relative_from": return 4;
                        case "format1": return 3;

                        case "range_units_to": return this.units_to == 'now' ? 8 : 3;
                        case "range_value_to": return 5;
                        case "range_abs_to": return 5;
                        case "format2": return 3;
                    }

                    return 4;
            },
            valueChanged(val) {
                if (val.value == 'now')
                    this.units_from = 'now';
                else if (val.value && val.value.substring(0, 3) == 'now') {
                    const { value, units, round } = common.parseFilter(val.value);
                    this.value_from = value;
                    this.units_from = units;
                    this.round_from = round;
                }
                else if (val.value && val.value.includes('T')) {
                    this.units_from = 'abs';
                    this.abs_from = common.ISO8601ToLocal(val.value);
                }

                if (val.valueTo == 'now')
                    this.units_to = 'now';
                else if (val.valueTo && val.valueTo.substring(0, 3) == 'now') {
                    const { value, units, round } = common.parseFilter(val.valueTo);
                    this.value_to = value;
                    this.units_to = units;
                    this.round_to = round;
                }
                else if (val.valueTo && val.valueTo.includes('T')) {
                    this.units_to = 'abs';
                    this.abs_to = common.ISO8601ToLocal(val.valueTo);
                }
                if (val.operator)
                {
                    this.itemCondition = val.operator;
                }
            },            
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            thresholdChanged() {

                    if (this.units_from == "now")
                    {
                        this.abs_from = "";
                        this.value_from = "";
                    } else if (this.units_from == "abs")
                    {
                        this.value_from = "";
                    } else 
                    {
                          this.abs_from = "";                      
                    }

                    if (this.units_to == "now")
                    {
                        this.abs_to = "";
                        this.value_to  = "";
                    } else if (this.units_to == "abs")
                    {
                        this.value_to = "";
                    } else 
                    {
                          this.abs_to = "";                      
                    }

                    if (this.itemCondition == 'missing')
                    {
                        this.units_from = "";
                        this.value_from = "";
                        this.abs_from = "";
                        this.round_from = "";
                        this.units_to = "";
                        this.value_to = "";
                        this.abs_to = "";
                        this.round_to = "";
                    }
                    console.log("Units From is: " + this.units_from);
                    console.log("Units To is: " + this.units_to);
                    const rule = {
                        filterType: 'number',
                        type: 'date',
                        value: this.getRelativeQuery(this.units_from, this.value_from, this.abs_from, this.round_from),
                        valueTo: this.getRelativeQuery(this.units_to, this.value_to, this.abs_to, this.round_to),
                        operator: this.itemCondition
                    };                  
                    this.$emit('thresholdValuesChanged', rule);

            },
            clearDateRangeHandler() {
            },

            formatDate(date){
                return filters.f_date(date, 'medium');
            },
            getFriendlyUnit(unit) {
                switch (unit) {
                    case 's': return this.Translate('second');
                    case 'm': return this.Translate('minute');
                    case 'h': return this.Translate('hour');
                    case 'd': return this.Translate('day');
                    case 'w': return this.Translate('week');
                    case 'M': return this.Translate('month');
                    case 'y': return this.Translate('year');
                    default: return '';
                }
            },
            getWeek(date) {
                let yearStart = new Date(date.getFullYear(), 0, 1);
                let today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                let dayOfYear = ((today - yearStart + 1) / 86400000);
                let week = Math.ceil(dayOfYear / 7);
                return week;
            },
            getDateOfWeek(w, y) {
                var d = (1 + (w - 1) * 7); // 1st of January + 7 days for each week

                return new Date(y, 0, d);
            },

            isActive(unit_type, unit_value, abs_value) {
                if (unit_type == 'now')
                    return true;
                else if (unit_type == 'abs')
                    return abs_value !== '';
                else
                    return unit_value !== '';
            },
            getRelativeQuery(unit_type, unit_value, abs_value, round) {
                if (unit_type == 'abs')
                    return new Date(abs_value).toISOString();

                let value = 'now';
                
                if (unit_type != 'now' && unit_value > 0)
                    value += `-${unit_value}${unit_type}`;
                else if (unit_type != 'now' && unit_value < 0)
                    value += `+${-unit_value}${unit_type}`;
                
                if (round && unit_type != 'now')
                    value += '/' + unit_type;

                return value;
            },
        }
    }
</script>

<style scoped lang="scss">
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    .customGrid {
        display: grid; 
        grid-template-columns: 1fr 4em 1fr; 
        grid-template-rows: auto;
        gap: 8px;
        justify-items: start;
        align-items: center;
    }

    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
</style>